import React, { PureComponent } from 'react';
import { Switch, styled } from '@material-ui/core';
import { regions } from '../../../constants/region';
import { Us, Ca } from 'react-flags-select';
import { getRegion, setRegion } from '../../../utils/session-util';

const StyledSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  '& .MuiSwitch-switchBase': {
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(18px)',
      color: '#EF6A00',
      '& + .MuiSwitch-track': {
        backgroundColor: 'gray',
        opacity: 1,
        border: 0
      }
    }
  },
  '& .MuiSwitch-track': {
    backgroundColor: 'gray',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500
    })
  }
}));

class RegionSelector extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      selectedRegion: !!getRegion() ? getRegion() : regions.USA
    };

    this.onChangeRegion = this.onChangeRegion.bind(this);
  }

  onChangeRegion(event) {
    const selectedRegion = event.target.checked ? regions.CAN : regions.USA;
    setRegion(selectedRegion);
    this.setState({ selectedRegion }, () => {
      if (!!this.props.onChangeRegion)
        this.props.onChangeRegion(selectedRegion);
    });
  }

  render() {
    const flagSize = this.props.size != null ? this.props.size : '25px';
    return (
      <>
        <Us style={{ fontSize: flagSize, marginLeft: '4px' }} />
        <StyledSwitch
          onChange={this.onChangeRegion}
          checked={this.state.selectedRegion === regions.CAN}
        />
        <Ca style={{ fontSize: flagSize }} />
      </>
    );
  }
}

export default RegionSelector;
